var render = function (_h,_vm) {var _c=_vm._c;return _c('div',{staticClass:"relation-separator"},[_c('span',[_vm._v("\n    "+_vm._s(_vm.props.condition === 'allOf' ? 'and' : 'or')+"\n  ")])])}
var staticRenderFns = []

export { render, staticRenderFns }